import "./index.css";

import Pages from "./router/Pages";
import React from "react";
import { useInitFeatureFlags } from "./utils/featureFlags";
import { useInitBeneficiosAplicar } from "./utils/beneficiosAplicar";

function App() {
  useInitFeatureFlags();
  useInitBeneficiosAplicar();
  return <Pages />;
}

export default App;
